var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useApiResource } from './useApiResource';
import { useQueryParams } from '.';
export function useQueryResource(options) {
    const _a = options || {}, { uri, apiTransform } = _a, queryOptions = __rest(_a, ["uri", "apiTransform"]);
    const { queryParams, updateParams } = useQueryParams(queryOptions);
    const { loading, resource } = useApiResource(uri, apiTransform ? apiTransform(queryParams) : queryParams);
    return {
        loading,
        queryParams,
        resource,
        updateParams
    };
}
